import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Outlet,
  Navigate,
  useLocation,
} from "react-router-dom";
import { animated, useTransition } from "@react-spring/web";

import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/actions/users";

import _ from "lodash";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import EventService from "../../services/event.service.jsx";
import AssetView, { LiteAssetView } from "../../pages/asset";
import StreamView from "../../pages/streams/index";
import Slider from "../slider";
import Hub from "../../pages/hub";
import LogIn from "../../pages/anonymous/login";
import { isAuthenticated } from "../../services/authentication.service";
import ReportsPage from "../../legacy/pages/reports";
import PerformanceReport from "../../legacy/pages/reports/performance";
import DiscoveryReport from "../../legacy/pages/reports/discovery";
import EngagementReport from "../../legacy/pages/reports/engagement";

import SearchPage from "src/legacy/pages/search/SearchPage";
import DetailedSearchPage from "src/legacy/pages/search/DetailedSearchPage";
import HubSearchPage from "src/legacy/pages/hubSearch/SearchPage";
import HubDetailedSearchPage from "src/legacy/pages/hubSearch/DetailedSearchPage";
import StreamSearchPage from "src/legacy/pages/streamSearch/SearchPage";
import StreamDetailedSearchPage from "src/legacy/pages/streamSearch/DetailedSearchPage";

import { localizedStrings } from "../../localization/index.jsx";
import { CollectionsPage, CollectionsGrid } from "../../pages/collections";
import { IKContext } from "imagekitio-react";
import GroupView from "../../pages/groups";
import { Bounce, ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import "../../index.scss";
import styles from "./app.module.scss";
import { fetchAccount } from "../../redux/actions/accounts";
import AppServices from "../appServices";
import userRoleService from "../../services/userRoles.service.js";
import subscriptionPlanService from "../../services/subscriptionPlan.service.js";
import { MainMenu } from "./components/menu/";
import { CollectionPage } from "../../pages/collection";
import MicrosoftWopiIntegration from "src/pages/asset/office";
import GDocEditor from "src/pages/asset/gdocs/edit";
import GDocEditorProcessing from "src/pages/asset/gdocs/sync";
import CreateAsset from "src/pages/createAsset";
import Conversations from "src/pages/conversations";
import IntegrationsPage from "src/legacy/pages/settings/integrations/integrations/IntegrationsPage";
import FreshsalesPage from "src/legacy/pages/settings/integrations/integrations/freshsales/FreshsalesPage";
import HubspotPage from "src/legacy/pages/settings/integrations/integrations/hubspot/HubspotPage";
import SalesforcePage from "src/legacy/pages/settings/integrations/integrations/salesforce/SalesforcePage";
import PipedrivePage from "src/legacy/pages/settings/integrations/integrations/pipedrive/PipedrivePage";
import ZohoPage from "src/legacy/pages/settings/integrations/integrations/zoho/ZohoPage";
import MsDynamicsPage from "src/legacy/pages/settings/integrations/integrations/msDynamics/MsDynamicsPage";
import IntercomPage from "src/legacy/pages/settings/integrations/integrations/intercom/IntercomPage";
import DriftPage from "src/legacy/pages/settings/integrations/integrations/drift/DriftPage";
import OutlookPage from "src/legacy/pages/settings/integrations/integrations/outlook/OutlookPage";
import CleverstoryPage from "src/legacy/pages/settings/integrations/integrations/cleverstory/index";
import GmailPage from "src/legacy/pages/settings/integrations/integrations/gmail/GmailPage";
import SmtpPage from "src/legacy/pages/settings/integrations/integrations/smtp/SmtpPage";
import GoogleAnalyticsPage from "src/legacy/pages/settings/integrations/integrations/googleAnalytics/GoogleAnalyticsPage";
import GoogleAnalytics4Page from "src/legacy/pages/settings/integrations/integrations/googleAnalytics4/GoogleAnalytics4Page";
import GoogleTagManagerPage from "src/legacy/pages/settings/integrations/integrations/googleTagManager/GoogleTagManagerPage";
import SixSensePage from "src/legacy/pages/settings/integrations/integrations/sixSense/SixSensePage";
import KlentyPage from "src/legacy/pages/settings/integrations/integrations/klenty/KlentyPage";
import OutreachPage from "src/legacy/pages/settings/integrations/integrations/outreach/OutreachPage";
import SalesloftPage from "src/legacy/pages/settings/integrations/integrations/salesloft/SalesloftPage";
import MarketoPage from "src/legacy/pages/settings/integrations/integrations/marketo/MarketoPage";
import ExternalScriptPage from "src/legacy/pages/settings/integrations/integrations/externalScript/ExternalScriptPage";
import PardotPage from "src/legacy/pages/settings/integrations/integrations/pardot/PardotPage";
import SlackPage from "src/legacy/pages/settings/integrations/integrations/slack/SlackPage";
import NetsuitePage from "src/legacy/pages/settings/integrations/integrations/netsuite/NetsuitePage";
import SettingsPage from "src/legacy/pages/settings/SettingsPage";
import PrivacyPolicy from "src/legacy/pages/settings/PrivacyPolicy";
import TermsAndConditions from "src/legacy/pages/settings/TermsAndConditions";
import FliteviewSettingsPage from "src/legacy/pages/settings/fliteview/FliteviewSettingsPage";
import HubSettingsPage from "src/legacy/pages/settings/hubSettings/index.jsx";
import CustomFieldContainer from "src/legacy/pages/settings/customFields/CustomFieldContainer";
import NDATemplatesContainer from "src/legacy/pages/settings/ndaTemplates"
import SmallTalkPage from 'src/legacy/pages/engage/index'
import ChatUsersListPage from "src/legacy/pages/engage/chatUsersList/index";
import PrivacyView from "src/legacy/pages/anonymous/legal/PrivacyView";

import ContentMap from "src/pages/contentMap";
import DistributionListContainer from "src/legacy/pages/settings/distributionLists/DistributionListContainer";
import ContactListDetailsContainer from "src/legacy/pages/settings/distributionLists/details/ContactListDetailsContainer";
import NotificationPage from "src/legacy/pages/settings/notifications";
import cx from "classnames";
import DealInsightsPage from "src/legacy/pages/dealInsights/index";
import DealDetailsPage from "src/legacy/pages/dealInsights/dealInformation";
import ProfilePage from "src/legacy/pages/settings/profile";
import DataSourcePage from "src/legacy/pages/settings/dataSource/DataSourcePage";
import DealRooms from "src/pages/dealRooms/index"
import StreamAccessManagementView from "src/legacy/pages/settings/streamAccessManagement/StreamAccessManagementView";
import PrivacyPolicyControlPage from "src/legacy/pages/settings/privacyPolicyControl/PrivacyPolicyControlPage";
import AccountManagementPage from "src/legacy/pages/settings/accountManagement/AccountManagementPage";
import UserManagementPage from "src/legacy/pages/settings/userManagement/UserManagementPage";
import UserManagementListContainer from "src/legacy/pages/settings/userManagement/list/UserManagementListContainer";
import UserDetailContainer from "src/legacy/pages/settings/userManagement/user/UserDetailContainer";
import UserGroupDetailPage from "src/legacy/pages/settings/userManagement/userGroup/UserGroupDetailPage";
import UserRoleDetailPage from "src/legacy/pages/settings/userManagement/userRole/UserRoleDetailPage";
import EmailTemplatePage from "src/legacy/pages/settings/emailTemplate/EmailTemplatePage";
import EmailTemplateDetailPage from "src/legacy/pages/settings/emailTemplate/EmailTemplateDetailPage";
import { EditConversationPage } from "src/pages/conversations/edit";
import { BackgroundUploadTaskManager } from "../asset/backgroundTask";
import { fetchActivatedWorkSpaces } from "src/redux/actions/cleverstory";
import Seek from "src/pages/seek";
import { toggleSeek } from "src/redux/actions/seek";
import AnonymousView from "src/pages/anonymous";
import SSOFailure from "src/pages/anonymous/ssoFailure";
import ForgotPassword from "src/pages/anonymous/forgotPassword";
import ActivateAccount from "src/pages/anonymous/activateAccount";
import Activation from "src/pages/anonymous/activation";
import ResetPassword from "src/pages/anonymous/resetPassword";
import AcceptInvitation from "src/pages/anonymous/acceptInvitation";
import SignInAs from "src/pages/anonymous/signInAs";
import { Account } from "src/types/accounts";
import { UncategorizedCollectionPage } from "src/pages/collection/uncategorized";
import hasAccess from "src/services/hasAccess.service";
import EmptyMessage from "../emptyMessage";
import PageNotFound from "../pageNotFound";
import { CoachingPage } from "src/pages/coaching";
import LinkedInIntegration from "src/pages/integrations/linkedIn";
import ComposePage from "../compose/components/page";
import GradientBackground from "../gradientBackground";
import { SSOSuccess } from "src/pages/anonymous/ssoSuccess";
import Home from "src/pages/home";
import ContactConversationsContainer from "src/legacy/lite/contactConversations";
import OpportunitySharesContainer from "src/legacy/lite/opportunities";
import OpportunityRecommendedAssetsContainer from "src/legacy/lite/opportunities/recommendedAssets";
import OpportunityRecommendedStreamContainer from "src/legacy/lite/opportunities/recommendedStream";
import MsDynamicsOpportunityRecommendedAssetsContainer from "src/legacy/lite/opportunities/msDynamicsRecommendedAssets";
import UniqueViewersContainer from "src/legacy/lite/reports/uniqueViewer";
import ShareViewContainer from "src/legacy/lite/reports/shareView";
import AssetViewContainer from "src/legacy/lite/reports/assetView";
import LeadViewContainer from "src/legacy/lite/reports/leadView";
import AssetShareAnalyticsContainer from "src/legacy/lite/assetShareAnalytics";
import OpportunityAssetShareAnalyticsContainer from "src/legacy/lite/opportunityAssetShareAnalytics";
import Opportunities from "src/legacy/lite/opportunitiesContainer";
import SkillContainer from "src/legacy/pages/settings/heySales/SkillContainer";
import ScenarioPage from "src/pages/coaching/sceanrios/components/scenario";
import Helmet from 'react-helmet';
import ReferralRedirectView from "src/pages/referral";
import { fetchSkills } from "src/redux/actions/coaching/skills";
import UnsubscribePage from "src/legacy/pages/settings/unsubscribe/UnsubscribePage";

import DealRoom from "src/pages/dealRoom";
import AssetsPage from "src/pages/dealRoom/pages/assets";
import OverView from "src/pages/dealRoom/pages/overview";
import PeoplePage from "src/pages/dealRoom/pages/people";
import ActivityPage from "src/pages/dealRoom/pages/activity";
import EngagePage from "src/pages/dealRoom/pages/engage";
import AppContextProvider from "./contexts/appContext";

// eslint-disable-next-line no-undef
const imageCDNUrl = process.env.REACT_APP_IMAGE_CDN;

function App() {
  const queryClient = new QueryClient();
  EventService.initialiseMixpanel();

  useEffect(() => {
    localizedStrings.setLanguage("en");

  }, []);

  const url = window.location.pathname;
  const isLiteApp = url.startsWith("/lite");

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Router basename={isLiteApp ? "/lite" : ""}>
          <Routes>
            <Route path="/" element={<AnonymousView />}>
              <Route path="/__login__/:id" element={<SignInAs/>}/>
              <Route path="/public/login" element={<LogIn />} />
              <Route path="/sso/success" element={<SSOSuccess />} />
              <Route path="/sso/failure" element={<SSOFailure />} />
              <Route
                path="/privacy"
                element={<PrivacyPolicy />}
              />
              <Route path="/unsubscribe/:contactId"
                element={<UnsubscribePage />} />
              <Route
                path="/terms"
                element={<TermsAndConditions />}
              />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:id" element={<ResetPassword />} />
              <Route
                path="/registration/activate/:id"
                element={<ActivateAccount />}
              />
              <Route path="/invitation/:id" element={<AcceptInvitation/>} />
            </Route>
            <Route path="/logout" element={<AnonymousView/>} />
            <Route path="/*" element={<ApplicationRoutes isLiteApp={isLiteApp} /> } />
            <Route path="/activate/success" element={<Activation />} />
          </Routes>
        </Router>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </>
  );
}

const ApplicationRoutes = ({ isLiteApp }: {
  isLiteApp: boolean,
}) => {
  return (
    <Routes>
      {isLiteApp && getLiteAppRoutes()}
      <Route path="/*" element={<AuthenticatedApplication/>}/>
    </Routes>
  )
}

const AuthenticatedApplication = () => {
  const dispatch = useDispatch();
  const [showComponent, setShowComponent] = useState(false);
  const [showSeek, setShowSeek] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const authenticated = isAuthenticated();

  const user = useSelector((state: any) => _.get(state, 'users.me'));
  const seek = useSelector((state: any) => _.get(state, 'seek.success')) || false;
  const seekSessionChats = useSelector((state: any) => _.get(state, 'seek.session.item.chats')) || [];
  const account = useSelector((state: any) => _.get(state, 'accounts.item'));
  const hideSideMenu = useSelector((state: any) => _.get(state, 'hub.hideSideMenu')) || showComponent;
  const isCleverStoryIntegrated = _.get(account,"cleverstoryIntegration")
  const activatedWorkSpaces = useSelector((state:any) => _.get(state,"cleverStory.activatedWorkSpaces.items"))

  const url = window.location.pathname;
  const isLiteApp = url.startsWith("/lite");
  const isLiteAssetView = _.includes(url, "liteAssetView");

  useEffect(() => {
    if (authenticated) {
      dispatch(fetchUserProfile());
      dispatch(fetchAccount());
    }
  }, [authenticated]);

  useEffect(() => {
    setShowSeek(seek);
  }, [seek])

  useEffect(() => {
    if (user && account) {
      userRoleService.initialise(user, account);
      subscriptionPlanService.initialise(account);
      
      if(isCleverStoryIntegrated && _.size(activatedWorkSpaces) === 0){
        dispatch(fetchActivatedWorkSpaces()); 
      }
      applyColorThemes(account);
    }
  }, [user, account]);

  const opacityTransitionHeader = useTransition(!hideSideMenu, {
    initial: { opacity: 1 },
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  const opacityTransitionCompose = useTransition(showComponent, {
    initial: { opacity: 1 },
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  const opacityTransitionBody = useTransition(!showComponent, {
    initial: { opacity: 1 },
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  const opacityTransition = useTransition(!hideSideMenu, {
    initial: { opacity: 1, height: "100%" },
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  if (!authenticated) {
    return <Navigate to={`/public/login?redirect=${url}`} />;
  }

  if (!(user && account)) {
    return <div className={styles.loading}>Loading Application...</div>;
  }
  
  const handleClick = () => {
    setExpanded(false); 
    setShowComponent(true);
  };

  const applyColorThemes = (account:Account) => {
    const root = document.documentElement;
    const primaryColor = _.get(account, 'theme.primaryColor', '#E51058');
    root.style.setProperty('--primaryColor', primaryColor);
    root.style.setProperty('height', '100vh');
    root.style.setProperty('overflow', 'hidden');
  }

  return (
    <AppContextProvider>
      <IKContext urlEndpoint={imageCDNUrl}>
        <div className={styles.app}>
          <div className={styles.header}>
            {opacityTransitionHeader(
              (style, item) =>
                item && (
                  <animated.div style={style} className={cx({[styles.expanded]: expanded})}>
                    <div className={styles.menuWrapper} onMouseEnter={() => setExpanded(true)} onMouseLeave={() => setExpanded(false)}> 
                      <MainMenu toggleCompose={handleClick} isDisabled={showSeek} expanded={expanded}/>
                    </div>
                  </animated.div>
                ),
            )}
            <GradientBackground showGradient={showSeek && !(seekSessionChats?.length > 0)} />
            {showSeek && <div className={styles.seekAnchor}>
              <Seek onClose={() => dispatch(toggleSeek())} />
            </div>}
            <div
              // Note: Update this ID in all instances where it is used
              id="app-body"
              className={cx(styles.body, {
                [styles.fullWidth]: isLiteAssetView || hideSideMenu,
                [styles.disableScroll]: showSeek,
                [styles.sideMenuExpanded] : expanded && !showSeek
              })}
            >
              {account && _.get(account,"theme.customStyleSheet") &&
                <Helmet key="1">
                  <link href={_.get(account,"theme.customStyleSheet")} rel="stylesheet" />
                </Helmet>
              }
              <Routes>
                <Route path="/" element={<ProtectedRoute />} >
                <Route path="/home" element={<Home />} />
                <Route path="/activate/success" element={<Activation />} />
                <Route path="/hub" element={<Hub />} >
                  <Route path="/hub/layout/:layoutId" element={<Hub />} />
                </Route>
                <Route
                  path="/assets/update-asset/:id"
                  element={<CreateAsset />}
                />
                <Route
                  path="/hub/create-asset/:type"
                  element={<CreateAsset />}
                />

                <Route path="/hub/content-map" element={<ContentMap />} >
                  <Route path=":id" element={<ContentMap />} />
                  <Route path="cluster/:id" element={<ContentMap />} />
                </Route>

                <Route path="/assets">
                  <Route path="/assets/:assetId" element={<AssetView />} />
                  <Route
                    path="/assets/office/:assetId"
                    element={<MicrosoftWopiIntegration />}
                  />
                  <Route
                    path="/assets/gdoc/:assetId"
                    element={<GDocEditor />}
                  />
                  <Route
                    path="/assets/gdoc/:assetId/finish-editing"
                    element={<GDocEditorProcessing />}
                  />
                </Route>
                <Route path="/streams/:id" element={<StreamView />} />
                <Route path="/groups/:id" element={<GroupView />} />
                <Route path="/collections" element={<CollectionsPage />}>
                  <Route path="/collections" element={<CollectionsGrid />} />
                  <Route
                    path="folders/:folderId"
                    element={<CollectionsGrid />}
                  />
                </Route>
                
                <Route path="/coaching/*" element={<CoachingPage />} />
                <Route path="/scenarios">
                  <Route path="/scenarios/:id" element={<ScenarioPage />} />
                </Route>
                
                
                <Route path="/reports" element={<ReportsPage />}>
                  <Route path="discovery" element={<DiscoveryReport />} />
                  <Route path="engagement" element={<EngagementReport />} />
                  <Route path="performance" element={<PerformanceReport />} />
                </Route>
                <Route path="/search" element={<SearchPage />} />
                <Route path="search/:page" element={<DetailedSearchPage />} />
                <Route path="/hub/search" element={<HubSearchPage />} />
                <Route
                  path="/hub/search/:page"
                  element={<HubDetailedSearchPage />}
                />

                <Route
                  path="/streams/:id/search"
                  element={<StreamSearchPage />}
                />
                <Route
                  path="/streams/:id/search/:page"
                  element={<StreamDetailedSearchPage />}
                />
                <Route path="/collections/uncategorized" element={<UncategorizedCollectionPage />} />
                <Route path="/collections/:id" element={<CollectionPage />}>
                  <Route
                    path="/collections/:id/sections/:sectionId"
                    element={<CollectionPage />}
                  />
                </Route>
                <Route path="/conversations" 
                element={<Conversations/>}
                >
                  <Route
                    path="/conversations/:id"
                    element={<Conversations/>}
                  />
                </Route>

                <Route path="/shares"
                    element={<Conversations />}
                >
                  <Route
                      path="/shares/:id"
                      element={<Conversations />}
                  />
                </Route>

                <Route
                    path="/deal-room/:id/"
                    element={<DealRoom />}
                  >
                    <Route path="/deal-room/:id/overview" element={<OverView />} />
                    <Route path="/deal-room/:id/assets/:type" element={<AssetsPage />} />
                    <Route
                      path="/deal-room/:id/assets/internal/sections/:sectionId"
                      element={<AssetsPage />}
                    />

                    <Route 
                      path="/deal-room/:id/people/:type"
                      element={<PeoplePage/>}/>
                    <Route path="/deal-room/:id/activity" element={<ActivityPage />} />

                    <Route
                      path="/deal-room/:id/engage"
                      element={<EngagePage />} />
                    <Route
                      path="/deal-room/:id/engage/:conversationId"
                      element={<EngagePage />} />
                  </Route>
                <Route path="/deal-rooms" element={<DealRooms />} />
                <Route path="/deal-rooms/:filterId" element={<DealRooms />} />

                {!isLiteApp && <>
                  <Route path="/settings" element={<SettingsPage />}>
                    <Route index element={<Navigate to="/settings/profile" />} />
                    <Route path="/settings/profile" element={<ProfilePage />} />
                    <Route
                      path="/settings/notifications"
                      element={<NotificationPage />}
                    />
                    <Route
                      path="/settings/account-management"
                      element={<AccountManagementPage />}
                    />
                    <Route
                      path="/settings/user-management"
                      element={<UserManagementPage />}
                    >
                      <Route
                        path=":filter"
                        element={<UserManagementListContainer />}
                      />
                    </Route>

                    <Route
                      path="/settings/user-roles"
                      element={<UserRoleDetailPage />}
                    />
                    <Route
                      path="/settings/user-roles/:id"
                      element={<UserRoleDetailPage />}
                    />

                    <Route
                      path="/settings/user-management/group/:id"
                      element={<UserGroupDetailPage />}
                    />
                    <Route
                      path="/settings/user-management/user/:id"
                      element={<UserDetailContainer />}
                    />
                    <Route
                      path="/settings/fliteview"
                      element={<FliteviewSettingsPage />}
                    />
                    <Route
                      path="/settings/hub-settings"
                      element={<HubSettingsPage />}
                    />
                    <Route
                      path="/settings/custom_fields"
                      element={<CustomFieldContainer />}
                    />
                    <Route
                      path="/settings/privacy-policy-control"
                      element={<PrivacyPolicyControlPage />}
                    />
                    <Route
                      path="/settings/privacy-policy"
                      element={<PrivacyPolicy />}
                    />
                    <Route
                      path="/settings/terms-and-conditions"
                      element={<TermsAndConditions />}
                    />
                    <Route
                      path="/settings/stream-access-management"
                      element={<StreamAccessManagementView />}
                    />
                    <Route
                      path="/settings/distribution_lists"
                      element={<DistributionListContainer />}
                    />
                    <Route
                      path="/settings/data-sources"
                      element={<DataSourcePage />}
                    />
                    <Route
                      path="/settings/contact_list"
                      element={<ContactListDetailsContainer />}
                    />
                    <Route
                      path="/settings/contact_list/:id"
                      element={<DistributionListContainer />}
                    />
                    <Route
                      path="/settings/email-template"
                      element={<EmailTemplatePage />}
                    />
                    <Route
                      path="/settings/email-template/:id"
                      element={<EmailTemplateDetailPage />}
                    />

                    <Route 
                    path="/settings/skills"
                    element={<SkillContainer />}
                    />

                    <Route
                      path="/settings/nda-templates"
                      element={<NDATemplatesContainer />}
                    />
                    <Route
                      path="/settings/nda-templates/:id"
                      element={<NDATemplatesContainer />}
                    />

                    <Route
                      path="/settings/integrations"
                      element={<IntegrationsPage />}
                    />
                  </Route>

                  <Route
                    path="/settings/integrations/linkedIn"
                    element={<LinkedInIntegration />}
                  />

                  <Route
                    path="/settings/integrations/cleverstory"
                    element={<CleverstoryPage />}
                  />

                  <Route
                    path="/settings/integrations/gmail"
                    element={<GmailPage />}
                  />

                  <Route
                    path="/settings/integrations/outlook"
                    element={<OutlookPage />}
                  />

                  <Route
                    path="/settings/integrations/salesforce"
                    element={<SalesforcePage />}
                  />

                  <Route
                    path="/settings/integrations/outreach"
                    element={<OutreachPage />}
                  />

                  <Route
                    path="/settings/integrations/pipedrive"
                    element={<PipedrivePage />}
                  />

                  <Route
                    path="/settings/integrations/freshsales"
                    element={<FreshsalesPage />}
                  />

                  <Route
                    path="/settings/integrations/pardot"
                    element={<PardotPage />}
                  />

                  <Route
                    path="/settings/integrations/slack"
                    element={<SlackPage />}
                  />

                  <Route
                    path="/settings/integrations/google-analytics"
                    element={<GoogleAnalyticsPage />}
                  />

                  <Route
                    path="/settings/integrations/google-analytics-4"
                    element={<GoogleAnalytics4Page />}
                  />

                  <Route
                    path="/settings/integrations/hubspot"
                    element={<HubspotPage />}
                  />

                  <Route
                    path="/settings/integrations/zoho"
                    element={<ZohoPage />}
                  />

                  <Route
                    path="/settings/integrations/netsuite"
                    element={<NetsuitePage />}
                  />

                  <Route
                    path="/settings/integrations/ms-dynamics"
                    element={<MsDynamicsPage />}
                  />

                  <Route
                    path="/settings/integrations/salesloft"
                    element={<SalesloftPage />}
                  />

                  <Route
                    path="/settings/integrations/smtp"
                    element={<SmtpPage />}
                  />

                  <Route
                    path="/settings/integrations/google-tag-manager"
                    element={<GoogleTagManagerPage />}
                  />

                  <Route
                    path="/settings/integrations/klenty"
                    element={<KlentyPage />}
                  />

                  <Route
                    path="/settings/integrations/six-sense"
                    element={<SixSensePage />}
                  />

                  <Route
                    path="/settings/integrations/marketo"
                    element={<MarketoPage />}
                  />

                  <Route
                    path="/settings/integrations/intercom"
                    element={<IntercomPage />}
                  />

                  <Route
                    path="/settings/integrations/external-script"
                    element={<ExternalScriptPage />}
                  />
                  <Route path="/privacy" element={<PrivacyView />}/>

                  <Route
                    path="/settings/integrations/driftchat"
                    element={<DriftPage />}
                  />

                  <Route path="/engage" element={<SmallTalkPage />} />
                  <Route path="/engage/:id" element={<ChatUsersListPage />} />

                  <Route path="/deal-insights" element={<DealInsightsPage />} />
                  <Route
                    path="/deal-insights/:id"
                    element={<DealDetailsPage />}
                  />
                </>}

                <Route
                  path="/conversations/:id/edit"
                  element={<EditConversationPage />}
                />
                <Route
                  path="/conversations/:id/sections/:sectionId/edit"
                  element={<EditConversationPage />}
                />

                <Route path="*" element={<PageNotFound />} />
                  <Route
                    path="/redirect"
                    element={<ReferralRedirectView />}
                  />
                </Route>
              </Routes>
            </div>
            <div>
              <AppServices />
            </div>
          </div>
          <Outlet />

          {opacityTransitionCompose(
            (style, item) =>
              item && (
                <animated.div style={style} className={styles.revealCompose}>
                  <ComposePage
                    page={true}
                    onFinish={() => setShowComponent(false)}
                    onClose={() => setShowComponent(false)}
                  />
                </animated.div>
              ),
          )}
        </div>
        <BackgroundUploadTaskManager />
        <ToastContainer
          position={"bottom-right"}
          pauseOnHover
          theme="light"
          transition={Bounce}
          className={styles.toastContainer}
          closeButton={false}
          hideProgressBar={true}
        />
      </IKContext>
    </AppContextProvider>
  );
};


const ProtectedRoute = ({ }) => {
  const location = useLocation();
  const route = location.pathname.split("/")[1];

  if(!userRoleService.isInitialized() || !subscriptionPlanService.isInitialized()){
    return <div className={styles.loading}>Loading Application...</div>;
  }

  return hasAccess(route) ? (
      <Outlet />
  ) : (
    <div className={styles.accessRestricted}>
      <EmptyMessage
        width="auto"
        image={'/images/no_access.svg'}
        heading="No access!"
        message="Oops! You do not have access to this module."
      />
    </div>
  );
};

const getLiteAppRoutes = () => {
  return (
    <>
      <Route path="/liteAssetView/:assetId"
        element={<LiteAssetView />}
      />

      <Route
        path="/analytics"
        element={<AssetShareAnalyticsContainer />}
      />

      <Route
        path="/opportunities/analytics"
        element={<OpportunityAssetShareAnalyticsContainer />}
      />

      <Route
        path="/contacts/:email/conversations"
        element={<ContactConversationsContainer />}
      />

      <Route path='/opportunities' element={<Opportunities />}>
        <Route
          path="/opportunities/:opportunityId/shares"
          element={<OpportunitySharesContainer />}
        />
        <Route
          path="/opportunities/:opportunityId/recommended-assets"
          element={<OpportunityRecommendedAssetsContainer />}
        />
        <Route
          path="/opportunities/:opportunityId/recommended-streams"
          element={<OpportunityRecommendedStreamContainer />}
        />
        <Route
          path="/opportunities/*"
          element={<></>}
        />
      </Route>

      <Route path='/msdynamics/opportunities' element={<Opportunities />}>
        <Route
          path="/msdynamics/opportunities/:opportunityId/recommended-assets"
          element={<MsDynamicsOpportunityRecommendedAssetsContainer />}
        />
        <Route
          path="/msdynamics/opportunities/*"
          element={<></>}
        />
      </Route>

      <Route
        path={"/reports/unique-viewers"}
        element={<UniqueViewersContainer />}
      />

      <Route
        path={"/reports/conversations"}
        element={<ShareViewContainer />}
      />

      <Route
        path={"/reports/assets"}
        element={<AssetViewContainer />}
      />

      <Route
        path={"/reports/leads"}
        element={<LeadViewContainer />}
      />
    </>
  );
}

export default App;